import component from './StudentsPage.container';

export default component;
